import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-warning",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.message)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.message), 1))
    : _createCommentVNode("", true)
}